import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "task-detail-box"
};
const _hoisted_2 = {
  style: {
    "margin-bottom": "20px",
    "text-align": "right"
  }
};
import { ref, reactive, onMounted, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { getAppPlanJobPage, planJobGetAppPlanJob, planGeneratedDetailGetAppPlanGeneratedDetail, planGeneratedGetAppPlanGenerated, planGeneratedDetailUpdate, planGeneratedDetailCreate, planGeneratedDetailBeforeRelease } from '@/request/aiPlanTask';
import { planGeneratedDetailGetReleasePlatform, checkCookie, uploadVideo } from '@/request/mediaPlatform';
import setDistribution from '@/views/workManage/components/setDistribution.vue';

// import { ElTable, ElTableColumn, ElPagination, ElInput, ElButton } from 'element-plus';
import { useRouter, useRoute } from 'vue-router';
import setting from './setting.vue';
export default {
  __name: 'taskDetail',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    let detailDialogId = ref('');
    let dialogVisible = ref(false);
    // 表格数据和分页数据
    const tableData = ref([]);
    const tableDetailData = ref([]);
    const total = ref(0);
    const multipleSelection = ref([]);

    // 一键发布设置
    const publishDrawer = ref(false);
    const publishIdModel = ref(null);
    const portfolioArr = ref([]);
    const bindMediaArr = ref([]);
    const statusDescriptions = {
      0: '待确认',
      1: '生成中',
      2: '已生成',
      3: '待发布',
      4: '已发布',
      5: '失败',
      6: '取消'
    };
    // 搜索和分页参数
    const searchParams = reactive({
      orderByColumn: '',
      orderByAsc: true,
      pageIndex: 1,
      pageSize: 10,
      keyword: ''
    });
    let detailsPlanJobForm = ref({});
    // 分页大小改变时
    const handleSizeChange = newSize => {
      searchParams.pageSize = newSize;
      fetchData();
    };

    // 当前页码改变时
    const handleCurrentChange = newPage => {
      searchParams.pageIndex = newPage;
      fetchData();
    };
    let refreshListFn = async () => {
      // 使用抽离的请求逻辑获取更新后的详情
      const data = await fetchPlanGeneratedDetail(detailDialogId.value);
      // 请求成功，处理数据
      tableDetailData.value = data.list.map(v => ({
        ...v,
        oldContent: v.content
      }));
    };
    let generateFn = async () => {
      var _multipleSelection$va, _multipleSelection$va2;
      let noGenerate = (_multipleSelection$va = multipleSelection.value) === null || _multipleSelection$va === void 0 ? void 0 : _multipleSelection$va.filter(v => [1, 2, 3, 4].includes(v.status));
      if (noGenerate !== null && noGenerate !== void 0 && noGenerate.length) {
        ElMessage.warning('生成中、已生成、待发布、已发布的视频不能再一键生成视频');
        return;
      }
      if ((_multipleSelection$va2 = multipleSelection.value) !== null && _multipleSelection$va2 !== void 0 && _multipleSelection$va2.length) {
        let res = await planGeneratedDetailCreate(multipleSelection.value.map(({
          id
        }) => id));
        ElMessage.success(res.data.msg);
        await refreshListFn();
      } else {
        ElMessage.warning('请选择需要生成的视频');
      }
    };
    async function checkCookiesAndRecordFailures(mediaIds) {
      const checkPromises = mediaIds.map(account => checkCookie({
        account
      }).then(res => ({
        account,
        code: res.data.code
      })).catch(error => ({
        account,
        error
      })));
      const results = await Promise.allSettled(checkPromises);
      const failedAccounts = results.filter(result => result.status === 'fulfilled' && result.value.code === 500).map(result => result.value.account);
      if (failedAccounts.length > 0) {
        // 如果有账号返回了500错误码，则返回这些账号
        return failedAccounts;
      } else {
        // 如果没有账号返回500错误码，则返回true
        return false;
      }
    }
    let publishFn = async ({
      row
    }) => {
      var _res$data$data;
      let multipleSelection = [row];
      let res = await planGeneratedDetailGetReleasePlatform(detailDialogId.value);
      let accounts = [...new Set(res.data.data.map(v => v.accountId))];
      if ((_res$data$data = res.data.data) !== null && _res$data$data !== void 0 && _res$data$data.length) {
        const result = await checkCookiesAndRecordFailures(accounts);
        if (result) {
          ElMessage.warning(result.map(account => `${account}账号过期请重新授权绑定`).join('，'));
          return;
        }
      } else {
        return ElMessage.warning('请先绑定多媒体账号');
      }
      if (accounts !== null && accounts !== void 0 && accounts.length && multipleSelection !== null && multipleSelection !== void 0 && multipleSelection.length) {
        let unPublishArr = multipleSelection === null || multipleSelection === void 0 ? void 0 : multipleSelection.filter(v => v.status !== 2);
        if (unPublishArr !== null && unPublishArr !== void 0 && unPublishArr.length) {
          ElMessage.warning('只有已生成的视频才能一键发布');
        } else {
          // 已生成的视频 检查能不能发布
          let okGeneratedVideoArr = multipleSelection.filter(v => v.status === 2);
          let resultBeforeRelease = await planGeneratedDetailBeforeRelease(okGeneratedVideoArr.map(({
            id
          }) => id));
          if (!resultBeforeRelease.data.data.length) return;
          // 媒体账号id
          bindMediaArr.value = accounts;
          portfolioArr.value = resultBeforeRelease.data.data.map(v => ({
            ...v,
            id: v.videoId
          }));
          publishIdModel.value = portfolioArr.value.map(({
            id
          }) => id).join('，');
          publishDrawer.value = true;
        }
      } else ElMessage.warning('请选择已生成的视频一键发布');
    };

    // 获取表格数据
    const fetchData = async () => {
      try {
        // 替换为你的API端点
        const response = await planGeneratedGetAppPlanGenerated({
          planId: route === null || route === void 0 ? void 0 : route.query.planId,
          ...searchParams
        });
        if (response && response.data) {
          // 假设返回的数据格式为 { list: [], total: Number }
          tableData.value = response.data.data.list;
          total.value = response.data.data.total;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // 处理选择变化
    const handleSelectionChange = arr => {
      multipleSelection.value = arr;
    };

    // 获取子详情列表
    function fetchPlanGeneratedDetail(generatedId) {
      // 返回一个Promise
      return new Promise((resolve, reject) => {
        planGeneratedDetailGetAppPlanGeneratedDetail({
          generatedId
        }).then(res => {
          // 请求成功，解析Promise
          resolve(res.data.data);
        }).catch(error => {
          // 请求失败，拒绝Promise
          reject(error);
        });
      });
    }
    let detailDialogFn = async ({
      row
    }) => {
      detailDialogId.value = row.id;
      // 使用抽离的请求逻辑获取更新后的详情
      const data = await fetchPlanGeneratedDetail(row.id);
      // 请求成功，处理数据
      tableDetailData.value = data.list.map(v => ({
        ...v,
        oldContent: v.content
      }));
      nextTick(() => {
        dialogVisible.value = true;
      });
    };
    let blurContentFn = async row => {
      try {
        // 检查内容是否有变化，如果没有变化则直接返回，不执行后续操作
        if (!row.content || row.content === row.oldContent) {
          return;
        }
        row.loading = true;

        // 更新内容
        await planGeneratedDetailUpdate({
          id: row.id,
          content: row.content
        });

        // 使用抽离的请求逻辑获取更新后的详情
        const data = await fetchPlanGeneratedDetail(row.generateId);

        // 请求成功，处理数据
        tableDetailData.value = data.list.map(v => ({
          ...v,
          oldContent: v.content
        }));

        // 请求完成后，显示成功消息
        nextTick(() => {
          row.loading = false;
          ElMessage.success('修改成功');
        });
      } catch (error) {
        // 处理可能的错误
        console.error('操作失败：', error);
      }
    };
    onMounted(() => {
      fetchData();
    });
    let openDetails = () => {
      var _route$query;
      if ((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.generatedId) {
        var _route$query2;
        detailDialogFn({
          row: {
            id: (_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.generatedId
          }
        });
      }
    };
    openDetails();
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).go(-1)),
        style: {
          "margin-bottom": "10px"
        }
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 返回 ")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: fetchData,
        style: {
          "margin-bottom": "10px"
        }
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode(" 刷新列表 ")])),
        _: 1
      }), _createVNode(_component_el_table, {
        data: tableData.value,
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "index",
          width: "50"
        }), _createVNode(_component_el_table_column, {
          prop: "planId",
          label: "策划id\t",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "description",
          label: "描述"
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          label: "状态"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.status === 0 ? '生成成功' : '生成失败'), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "generatedTime",
          label: "生成时间"
        }), _createVNode(_component_el_table_column, {
          prop: "createId",
          label: "创建人"
        }), _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => _unref(detailDialogFn)(scope)
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" 详情 ")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "current-page": searchParams.pageIndex,
        "page-sizes": [10, 20, 50, 100],
        "page-size": searchParams.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: total.value
      }, null, 8, ["current-page", "page-size", "total"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : dialogVisible = $event),
        title: "详情",
        width: "70%",
        top: "30px"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(generateFn)
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode(" 一键生成视频 ")])),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(refreshListFn)
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode(" 刷新列表 ")])),
          _: 1
        }, 8, ["onClick"])]), _createVNode(_component_el_table, {
          "max-height": "600",
          data: tableDetailData.value,
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "index",
            width: "50"
          }), _createVNode(_component_el_table_column, {
            type: "selection",
            width: "35"
          }), _createVNode(_component_el_table_column, {
            prop: "content",
            label: "生成文案"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("div", null, [_withDirectives(_createVNode(_component_el_input, {
              modelValue: row.content,
              "onUpdate:modelValue": $event => row.content = $event,
              autosize: {
                minRows: 15,
                maxRows: 30
              },
              type: "textarea",
              placeholder: "生成文案",
              onBlur: $event => _unref(blurContentFn)(row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]), [[_directive_loading, row.loading]])])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "riskWarning",
            label: "风险提醒",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "errorMsg",
            label: "错误信息",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "status",
            label: "状态",
            width: "55"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(statusDescriptions[scope.row.status]), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "100"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => _unref(publishFn)(scope)
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" 发布抖音 ")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_drawer, {
        modelValue: publishDrawer.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => publishDrawer.value = $event),
        title: "发布面板"
      }, {
        default: _withCtx(() => [_createVNode(setDistribution, {
          publishDrawer: publishDrawer.value,
          "onUpdate:publishDrawer": _cache[2] || (_cache[2] = $event => publishDrawer.value = $event),
          publishIdModel: publishIdModel.value,
          "onUpdate:publishIdModel": _cache[3] || (_cache[3] = $event => publishIdModel.value = $event),
          portfolioArr: portfolioArr.value,
          bindMediaArr: bindMediaArr.value
        }, null, 8, ["publishDrawer", "publishIdModel", "portfolioArr", "bindMediaArr"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};